import { render, staticRenderFns } from "./payOutReject.vue?vue&type=template&id=241b1dc5"
import script from "./payOutReject.vue?vue&type=script&lang=ts"
export * from "./payOutReject.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports